import { defineStore } from 'pinia'
import { isAxiosError } from 'axios'
import { mentorshipApi } from '../services/mentorshipApi'
import type { MentorshipCaseListItem } from '../types'
import { getApiError } from '@/composables/getApiError'

export const createCaseFilters = () => ({
  search: '',
  status: [] as string[],
  mentee: [] as string[],
  mentor: [] as string[],
  department: [] as string[],
  end_after: null as string | null,
  end_before: null as string | null,
})
export const useMentorshipCasesStore = defineStore('mentorshipCases', {
  state: () => ({
    items: [] as MentorshipCaseListItem[],
    total: 0,
    loading: false,
    error: null as string | null,
    filters: createCaseFilters(),
    page: 1,
    currentSortString: '-number' as string | null,
    sortBy: [{ key: 'number', order: 'desc' as const }] as Array<{ key: string; order: 'asc' | 'desc' }>,
    workspace: 'all' as 'all' | 'mentor' | 'mentee',
    requestSequence: 0,
  }),
  getters: {
    filterParams: state => Object.fromEntries(Object.entries(state.filters)
      .filter(([, value]) => value !== null && value !== '' && (!Array.isArray(value) || value.length))
      .map(([key, value]) => [key, Array.isArray(value) ? value.join(',') : value])),
  },
  actions: {
    async fetchCases(params: Record<string, unknown> = {}): Promise<void> {
      const sequence = ++this.requestSequence
      this.loading = true
      this.error = null
      try {
        const data = await mentorshipApi.getCases({
          ...this.filterParams,
          workspace: this.workspace,
          page: this.page,
          ordering: this.currentSortString || '-number',
          ...params,
        })
        if (sequence !== this.requestSequence) return
        this.items = data.results
        this.total = data.count
      } catch (error) {
        if (sequence !== this.requestSequence) return
        if (isAxiosError(error) && error.response?.status === 404 && this.page > 1) {
          this.page = 1
          await this.fetchCases(params)
          return
        }
        this.items = []
        this.total = 0
        this.error = getApiError(error, 'Не удалось загрузить реестр наставничества')
      } finally {
        if (sequence === this.requestSequence) this.loading = false
      }
    },
  },
})
